import React from 'react';
import PropTypes from 'prop-types';
import Icon from '~/components/common/icon';

/**
 * Undo button
 *
 * @callback undoActionHandler
 * @param {Object} props
 * @param {undoActionHandler} props.undoActionHandler
 */
const UndoButton = ( { undoActionHandler } ) => (
	<button onClick={ undoActionHandler } className="ld-undo-button">
		<Icon icon="undo" />
		{ `${ LearnDashData.i18n.undo }` }
	</button>
);

/**
 * Valid props
 */
UndoButton.propTypes = {
	undoActionHandler: PropTypes.func,
};

export default UndoButton;
